import * as React from 'react';
import styled from 'styled-components';
import Colours from '../State/Colours';
import Context from '../State/Context';
import devices from '../State/Devices';
import Button from './Button';
import ButtonGray from './ButtonGray';
import ButtonStartOver from './ButtonStartOver';
import { ArrowLeft, ArrowRight } from './Icons';

const PageNavigationFooterStyled = styled.div`
    display: block;
    height: auto;
    margin-top: 8px;
`;

const ButtonContainer = styled.div`
    display: -ms-grid;            
    display: grid;
    position: relative;
    grid-template-columns: 1fr 1fr;
    -ms-grid-columns: 1fr 1fr;
    height: 40px;
    margin-bottom: 60px;

    button {
        position: absolute;
        bottom: 0;
    }

    .left { left: 0; }
    .right { right: 0; }
    .show { display: block; }
    .hide { display: none; }
`;

const ButtonStartOverContainer = styled.div`
    display: none;

    @media ${devices.laptop}  {
        background-color: ${Colours.panelBackground};
        display: -ms-grid;
        display: grid;
        grid-template-columns: auto 1fr;
        -ms-grid-columns: auto 1fr;
        padding: 10px;
        align-items: center;
        margin: 0 -20px;

        button {
            margin: 8px 4px;
        }

        .startOverDescription {
            padding: 4px 4px;
            font-size: 0.8em;
            text-align: center;
        }
    }
`;

export default () => (
    <Context.Consumer>
        {({ page, maxPages, onNextPage, onPreviousPage, onReset, messages, isCurrentPageComplete }) => (
            <PageNavigationFooterStyled className="PageNavigationFooter">
                <ButtonContainer>
                    <ButtonGray className={"left" + (page > 1 ? ' show' : ' hide')} onClick={onPreviousPage}>
                        <ArrowLeft/> {messages.buttonPrevious}
                    </ButtonGray>
                    <Button className={"right" + (page < maxPages ? ' show' : ' hide')} disabled={!isCurrentPageComplete()} onClick={onNextPage}>
                        {messages.buttonNext} <ArrowRight/>
                    </Button>
                </ButtonContainer>

                <ButtonStartOverContainer>
                    <ButtonStartOver showDescription={true} onReset={onReset}/>
                </ButtonStartOverContainer>
            </PageNavigationFooterStyled>
        )}
    </Context.Consumer>
);


// WEBPACK FOOTER //
// ./src/Components/PageNavigationFooter.tsx